import { sva } from "@agapi/ui/panda/css";

export const similarProductsStyles = sva({
  slots: ['container', 'title', 'productList'],
  base: {
    container: {
      px: 4,
      py: 4,
      gap: 4,
    },
    title: {
      textStyle: 'h3',
      color: 'text.heading',
      mb: 4,
    },
    productList: {
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
    },
  },
});